<script>
import { mapActions } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    extends: TableView,

    props: {
        userId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            includeHeader: false,
            includeDeleteAction: false
        };
    },

    computed: {
        additionalFetchData() {
            return {
                userId: this.userId
            };
        },

        options() {
            return {
                addButton: false
            };
        },

        labels() {
            return [
                { value: 'number', type: 'number', width: '180px' },
                {
                    value: 'createdAt',
                    text: 'Date',
                    filter: 'formatDate',
                    width: '200px',
                    type: 'date'
                },
                {
                    value: 'totalPrice',
                    type: 'number',
                    filter: 'formatPrice',
                    width: '180px'
                },
                {
                    value: 'shop.name',
                    text: 'Supplier',
                    width: '180px'
                },
                {
                    value: 'paymentMethod',
                    type: 'enum',
                    enumOptions: ['credit', 'stars', 'credit&stars'],
                    width: '180px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'orders/index'
        }),

        onRowClick({ id }) {
            this.$router.push(`/orders/${id}/edit`);
        }
    }
};
</script>
